import { ErrorMessage } from "./ErrorMessage";
import { getClassForState } from "../utils";
import shared from "../../data/js/shared";

const {
	nameLabel,
	emailLabel,
	emailOptionalLabel,
	nameInvalidErrorMessage,
	lastNameNeededErrorMessage,
	emailTakenErrorMessage,
	emailEmptyErrorMessage,
	emailInvalidErrorMessage,
} = shared.login;

export interface FormInputsState {
	name?: string;
	email?: string;
	[key: string]: string | undefined;
}

export interface FormInputsErrors {
	name?: string | null;
	email?: string | null;
	[key: string]: string | null | undefined;
}

export interface FormInputsFocus {
	name?: boolean;
	email?: boolean;
	[key: string]: boolean | undefined;
}

export interface NameInputProps {
	value: string;
	error: string | null | undefined;
	focus: boolean;
	onChange: (value: string) => void;
	onFocus: () => void;
	onBlur: () => void;
}

export interface EmailInputProps {
	/** Label the field optional — more-info saves a name without an address. */
	optional?: boolean;
	value: string;
	error: string | null | undefined;
	focus: boolean;
	onChange: (value: string) => void;
	onFocus: () => void;
	onBlur: () => void;
}

/**
 * NameInput Component
 *
 * Input field for user's full name with validation
 */
export const NameInput = ({
	value,
	error,
	focus,
	onChange,
	onFocus,
	onBlur,
}: NameInputProps) => {
	const focusFilled = focus || value ? "focus filled" : "";
	const errorClass = getClassForState("name", error);

	return (
		<label
			className={`input-label input-label-name ${focusFilled} ${errorClass}`}
			htmlFor="name-input"
		>
			<span className="input-placeholder name-label">{nameLabel}</span>
			<input
				type="text"
				id="name-input"
				name="name-input"
				className="form-input bordered"
				data-testid="name-input"
				value={value}
				onBlur={onBlur}
				onFocus={onFocus}
				onChange={(e) => onChange(e.target.value)}
			/>
			<div className="valid-check" />
			<ErrorMessage
				cls="name-invalid-error"
				msg={nameInvalidErrorMessage}
			/>
			<ErrorMessage
				cls="lastName-needed-error"
				msg={lastNameNeededErrorMessage}
			/>
		</label>
	);
};

/**
 * EmailInput Component
 *
 * Input field for user's email with validation
 */
export const EmailInput = ({
	optional = false,
	value,
	error,
	focus,
	onChange,
	onFocus,
	onBlur,
}: EmailInputProps) => {
	const focusFilled = focus || value ? "focus filled" : "";
	const errorClass = getClassForState("email", error);

	return (
		<label
			className={`input-label input-label-email ${focusFilled} ${errorClass}`}
			htmlFor="email"
		>
			<span className="input-placeholder email-label">
				{optional ? emailOptionalLabel : emailLabel}
			</span>
			<input
				type="email"
				id="email-input"
				name="email"
				inputMode="email"
				className="form-input bordered"
				data-testid="email-input"
				value={value}
				onBlur={onBlur}
				onFocus={onFocus}
				onChange={(e) => onChange(e.target.value)}
			/>
			<div className="valid-check" />
			<ErrorMessage
				cls="email-taken-error"
				msg={emailTakenErrorMessage}
			/>
			<ErrorMessage
				cls="email-empty-error"
				msg={emailEmptyErrorMessage}
			/>
			<ErrorMessage
				cls="email-invalid-error"
				msg={emailInvalidErrorMessage}
			/>
		</label>
	);
};

